import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

const CLASSES = {
    isOpened: "is-opened",
};

export default class extends Controller {
    static targets = ["input"];

    connect() {
        useClickOutside(this);
    }

    clickOutside() {
        this.close();
    }

    open() {
        this.element.classList.add(CLASSES.isOpened);
    }

    close() {
        this.element.classList.remove(CLASSES.isOpened);
    }
}
